<script>
import draggable from 'vuedraggable'
import ImageTools from '@/utils/imagetools'
import Queue from 'promise-queue'

let imageTools = new ImageTools()
let queue = new Queue(2, Infinity)

export default {
  name: 'FilePickerComponent',
  components: { draggable },
  props: {
    maxThumbnailSize: {
      type: Number,
      default: 220
    }
  },
  mounted () {
    // const pictures = []
    // const pictures = JSON.parse('[{"id":13724,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/-YKGGvA3bn.png"},{"id":13725,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/bnC-OWCSrX.jpeg"},{"id":13726,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/JbBoWBi5HZ.jpeg"},{"id":13727,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/9PNSe0Msjy.jpeg"},{"id":13728,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/QIc_E8Hm47.jpeg"},{"id":13729,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/F85ovmlIW9.jpeg"},{"id":13730,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/P4QiQ_LQaS.jpeg"},{"id":13731,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/FSXysFz65W.jpeg"},{"id":13732,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/cuBvffcawV.jpeg"},{"id":13733,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/j-sIHhV6Gy.jpeg"},{"id":13734,"path":"cars\\/600ead94-dc39-11e8-885d-0242ac120002\\/z4bqab8wlx\\/oqU--7Xlkg.jpeg"}]')
    // const pictures = JSON.parse('[{"id":12528,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/KA1qJXyYXD.jpeg","position":0},{"id":12529,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/es6P-q8i_m.jpeg","position":1},{"id":12530,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/Lp5hZna2kv.jpeg","position":2},{"id":12531,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/Np9Nku9Tds.jpeg","position":3},{"id":12532,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/zYY0V4NSba.jpeg","position":4},{"id":12533,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/pftuLa-MaX.jpeg","position":5},{"id":12534,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/DNY33klcQ_.jpeg","position":6},{"id":12535,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/3-1miI6BlJ.jpeg","position":7},{"id":12536,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/-E5VlGc3cA.jpeg","position":8},{"id":12537,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/gzCmbn7xUL.jpeg","position":9},{"id":12538,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/HXoIuYqKg8.jpeg","position":10},{"id":12539,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/l0XBnq4Lk5.jpeg","position":11},{"id":12540,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/JyJ5wA6RKk.jpeg","position":12},{"id":12541,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/Ery-J0ESxz.jpeg","position":13},{"id":12542,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/ohUs0Q2cm6.jpeg","position":14},{"id":12543,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/VerwZlJFaa.jpeg","position":15},{"id":12544,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/FKxc20-B4T.jpeg","position":16},{"id":12545,"path":"cars\\/1ca4f5b3-dc39-11e8-885d-0242ac120002\\/fe6fnce1ob\\/uIGh-MdX_A.jpeg","position":17}]')
    // this.setPictures(pictures)
    // setInterval(() => {
    //   console.log('pictures', this.getPictures())
    //
    // }, 1000)
  },
  data () {
    return {
      files: [],
      loading: false
    }
  },
  methods: {
    setPictures (rawPictures) {
      // this.loading = true
      rawPictures.forEach(rawPicture => {
        let uniqueKey = `${new Date().getTime()}${Math.floor((Math.random() * 1000000) + 1)}`
        let picturePath = rawPicture.thumb
        if (picturePath === null) {
          picturePath = rawPicture.path
        }
        this.files.push({file: null, content: `${process.env.PICTURE_ENDPOINT}/${picturePath}`, uniqueKey, extra: rawPicture})
      })
      // rawPictures.forEach(rawPicture => {
      //   downloadImageQueue
      //     .add(() => {
      //       let picturePath = rawPicture.thumb
      //       if (picturePath === null) {
      //         picturePath = rawPicture.path
      //       }
      //       return this.fileFromUrl(`${process.env.PICTURE_ENDPOINT}/${picturePath}`, `id#${rawPicture.id}.jpg`, rawPicture)
      //     })
      //     .then(file => {
      //       logger.info(`File ${rawPicture.id} downloaded in ${new Date().getTime() - timeStartDownload} ms`)
      //       timeStartDownload = new Date().getTime()
      //       this.addSingleFile(file, rawPicture)
      //       this.loading = downloadImageQueue.getPendingLength() > 0 || queue.getPendingLength() > 0
      //     })
      // })
    },
    getPictures () {
      return {
        pictures: this.files.map(file => file.file),
        picturesMetadata: this.files.map((file, index) => {
          return {
            id: file.extra !== undefined ? file.extra.id : null,
            position: index,
            originalPosition: file.extra !== undefined ? file.extra.position : null
          }
        })}
    },
    base64FromFile: file => new Promise((resolve, reject) => {
      let reader = new FileReader()
      reader.onload = event => {
        resolve(event.target.result)
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    }),
    deleteFile (file) {
      let index = this.files.indexOf(file)
      if (index > -1) {
        if (window.confirm('¿Seguro que quieres eliminar esta fotografía?')) {
          this.files.splice(index, 1)
        }
      }
    },
    onDrop (event) {
      if (event.dataTransfer.files.length > 0) {
        event.preventDefault()
        this.addBatchOfFiles(event.dataTransfer.files)
        event.dataTransfer.dropEffect = 'copy'
        this.$refs.draggableZone.$el.classList.remove('draggable_dragging')
      }
    },
    onDragOver (e) {
      e.preventDefault()
      this.$refs.draggableZone.$el.classList.remove('draggable_dragging')
    },
    onDragLeave (e) {
      e.preventDefault()
      this.$refs.draggableZone.$el.classList.remove('draggable_dragging')
    },
    onHandleChange (e) {
      e.preventDefault()
      this.addBatchOfFiles(this.$refs.filesInput.files)
    },
    addBatchOfFiles (files) {
      Array.from(files).forEach(file => this.addSingleFile(file))
    },
    addSingleFile (file, rawPicture) {
      queue
        .add(() => new Promise((resolve, reject) => {
          imageTools.resize(file, { width: 900, height: 600 }).then(fileResized => {
            imageTools.resize(fileResized, {
              width: this.maxThumbnailSize,
              height: this.maxThumbnailSize
            }).then(thumbnail => {
              this.base64FromFile(thumbnail).then(base64 => {
                let uniqueKey = `${new Date().getTime()}${Math.floor((Math.random() * 1000000) + 1)}`
                resolve({file: fileResized, content: base64, uniqueKey, extra: rawPicture})
              })
            }).catch(reject)
          })
        }))
        .then(promiseResult => {
          this.files.push(promiseResult)
        })
        .finally(() => {
          this.loading = queue.getPendingLength() > 0
        })
    },
    onClickZoneFile (e) {
      if (!e.target.classList.contains('files_empty')) {
        e.preventDefault()
        return
      }
      e.preventDefault()
      if (this.files.length === 0) {
        let event = new MouseEvent('click')
        this.$refs.filesInput.dispatchEvent(event)
      }
    },
    onClickAddFile (e) {
      e.preventDefault()
      let event = new MouseEvent('click')
      this.$refs.filesInput.dispatchEvent(event)
    }
  }
}
</script>

<template>
  <div>
    <div class="box box-default box-basic-data">
      <div class="overlay" v-if="loading">
        <i class="fa fa-refresh fa-spin"></i>
      </div>
      <div class="box-header with-border">
        <div class="box-title">Fotos del vehículo</div>
      </div>
      <slot></slot>
      <div class="box-body" v-on:drop="onDrop" v-on:dragleave.prevent="onDragLeave" v-on:dragexit="onDragLeave" v-on:dragover="onDragOver" v-on:click.prevent="onClickZoneFile">

        <draggable v-model="files" ref="draggableZone" class="row filesContainer"  v-show="files.length > 0">
          <div v-for="(file, index) in files" v-if="file !== undefined" :key="file.uniqueKey" class="fileItem col-xs-12 col-sm-6 col-md-3 col-lg-2">
            <div class="fileBox">
              <div class="fileHeader">
                <small><b>{{index === 0 ? "PRINCIPAL" : "&nbsp;"}}</b></small>
                <div style="float:right"><div class="fa fa-trash icon-trash" v-on:click="deleteFile(file)"></div></div>
              </div>
              <img v-bind:src="file.content" class="img-file" v-bind:class="{ 'img-principal': index === 0}"/>
            </div>
          </div>
        </draggable>
        <div>

          <div class="filesContainer" v-if="files.length === 0">
            <div class="files_empty">¡Puedes arrastras y soltar las fotos a esta zona para añadirlas todas a la vez!</div>
          </div>
          <div class="file btn btn-success" v-on:click.prevent="onClickAddFile">+ Añadir fotografías<input ref="filesInput" type="file" name="file" multiple accept="image/*" v-on:change="onHandleChange"/></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

  .box-body {
    padding: 20px;
  }

  .zoneFile {
    cursor: pointer;
  }

  .files_empty {
    width: 100%;
    font-size: 1.5em;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    padding: 2.0em;
    color: #c8c8c8;
    text-align: center;
  }

  .filesContainer {
    margin: 20px;
    border: 1px dashed #ebebeb;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    padding: 20px;
  }

  .fileItem {
    clear:right;
    /*min-height: 50px;*/
  }
  .fileBox {
    border-radius: 5px;
    background-color: #ffffff;
    border: 1px solid #ebebeb;
    height: 100%;
    width: 100%;
    margin: 20px auto;
  }

  .img-file {
    border-radius: 5px;
    cursor: move;
    width: 100%;
    /*max-height: calc(75vh*0.2);*/
    /*min-height: calc(75vh*0.2);*/
    max-height: calc(100vw*0.1);
    min-height: calc(100vw*0.1);
    object-fit: cover;
    overflow-y: hidden; // Cuts off the parts of the image poking out

    @media only screen and (max-width: 768px) {
      max-height: calc(100vw*0.5);
      min-height: calc(100vw*0.5);
    }

    @media only screen and (min-width: 769px) and (max-width: 992px) {
      max-height: calc(100vw*0.15);
      min-height: calc(100vw*0.15);
    }

    @media only screen and (min-width: 993px) and (max-width: 1200px) {
      max-height: calc(100vw*0.1);
      min-height: calc(100vw*0.1);
    }

    @media only screen and (min-width: 1200px) {
      max-height: calc(100vw*0.07);
      min-height: calc(100vw*0.07);
    }
  }

  .img-file:hover {
    opacity: 0.9;
    cursor: move;
    -webkit-box-shadow: 10px 10px 5px 0 rgba(0,0,0,0.03);
    -moz-box-shadow: 10px 10px 5px 0 rgba(0,0,0,0.03);
    box-shadow: 10px 10px 5px 0 rgba(0,0,0,0.03);
  }
  .fileHeader {
    padding: 0 5px;
  }

  .icon-trash {
    cursor: pointer;
    padding: 0 8px 0 8px;
  }

  .sortable-drag {
    border: 1px solid antiquewhite;
    border-radius: 20px;
    background-color: transparent;
    background-image: none;
  }

  .draggable_dragging {

    background-color: rgba(255, 254, 67, 0.10) !important;

    .img-file:hover {
      opacity: 1;
      cursor: default;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }
  }

  .sortable-chosen {
    -webkit-box-shadow: 10px 10px 5px 0 rgba(0,0,0,0.10);
    -moz-box-shadow: 10px 10px 5px 0 rgba(0,0,0,0.10);
    box-shadow: 10px 10px 5px 0 rgba(0,0,0,0.010);
  }

  input[name="file"] {
    position: absolute;
    font-size: 50px;
    opacity: 0;
    right: 0;
    top: 0;
  }

  div.file {
    position: relative;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/FilePickerComponent.vue